import { bindActionCreators } from 'redux';

import UiBlocker from '../../services/UiBlocker';
import store from '../../store';
import * as actions from '../../store/actions/downloadList';
import localization from '../../shared/strings';
import { showErrorDialog } from '../../components/dialog';
import getZipUrls from '../assets/getZipUrls';

const downloadListActions = bindActionCreators({ ...actions }, store.dispatch);

async function downloadAssetWithWatermark(params, assets) {
  // We always poll the zipper status json (pollUrl), so zipper must write it
  const data = { enabledPolling: true, ...params };
  let urls;
  try {
    UiBlocker.block('Preparing');
    const { data: res } = await getZipUrls(data);
    urls = res;
  } catch (err) {
    showErrorDialog(localization.DOWNLOADDIALOG.errorCantCreateArchive);
  }
  UiBlocker.unblock();

  if (urls) {
    const pollUrl = urls.zipUrl.replace(/\.zip$/, '.json');

    if (data.isArchive) {
      downloadListActions.addToDownloadList([
        {
          name: urls.zipUrl.replace(/(.*|\/)\//, ''),
          mimeType: 'application/zip',
          url: urls.zipUrl,
          pollUrl,
          jobHash: urls.jobHash,
        },
      ]);
    } else {
      const needToChangeExtension = data.mimeType !== 'original';
      const listFiles = assets
        .filter((asset) => urls.fileUrls[asset._id])
        .map((asset) => {
          const fileUrl = urls.fileUrls[asset._id];
          const extension = (fileUrl || '').split('.').pop();

          let name = fileUrl.replace(/(.*|\/)\//, '');
          if (asset.name) name = asset.name;
          if (needToChangeExtension && extension) {
            name = name.replace(/\.\w+$/, `.${extension}`);
          }
          return {
            _id: asset._id,
            name,
            mimeType: 'original',
            url: fileUrl,
            pollUrl,
            jobHash: urls.jobHash,
          };
        });

      downloadListActions.addToDownloadList(listFiles);
    }
  }
}

export default downloadAssetWithWatermark;
